import { Controller } from "@hotwired/stimulus"

// Preserve the existing Ads action; its codeless rule is locked to the old domain.
export default class extends Controller {
  connect() {
    if (window.location.hostname !== "lophocdan.com") return
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.element.dataset.conversionSent === "true") return
    if (typeof window.gtag !== "function") return

    window.gtag("event", "conversion", {
      send_to: "AW-687972822/M37HCPi21_YZENbDhsgC",
      value: 300000,
      currency: "VND"
    })

    // Turbo restores this flag with the cached page, preventing duplicate events.
    this.element.dataset.conversionSent = "true"
  }
}
